import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "optionAppleCarplay"
const OptionAppleCarplayIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.092 7.72c-.085-.064-.182-.12-.262-.12a.374.374 0 0 0-.367.371v7.924a.375.375 0 0 0 .19.323.363.363 0 0 0 .37-.009c.07-.044 6.71-3.871 6.774-3.928a.371.371 0 0 0 .03-.53c-.067-.074-6.624-3.949-6.735-4.031Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.564 2C7.122 2 2.7 6.489 2.7 12s4.422 10 9.864 10c3.144 0 6.125-1.54 7.977-4.117l.005-.006a.84.84 0 0 0-.193-1.145.819.819 0 0 0-1.142.166l-.004.006c-1.545 2.148-4.028 3.429-6.643 3.429-4.526 0-8.214-3.736-8.214-8.333 0-4.598 3.688-8.333 8.214-8.333 2.62 0 5.107 1.286 6.65 3.44l.005.006a.824.824 0 0 0 1.142.168.84.84 0 0 0 .194-1.145l-.004-.006C18.7 3.545 15.714 2 12.564 2Z"
      />
    </svg>
  )
}
export default OptionAppleCarplayIcon
